

import React, { memo, useCallback, useState } from 'react'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'

import * as styles from './styles.module.scss'
import Svg from '../svg/svg'
import { InfoTooltipProps } from './types'

const InfoTooltip = ({
   content,
   customTrigger,
   ariaLabel,
   openIcon,
   closedIcon,
   inlineStyle,
   width,
   height,
   placement,
   maxWidth,
}: InfoTooltipProps ): JSX.Element => {
   const [isOpen, setIsOpen] = useState<boolean>(false)

   const onShow = useCallback(() => setIsOpen(true), [])

   const onHide = useCallback(() => setIsOpen(false), [])

   return (
      <Tippy
         className={styles.content}
         content={content}
         maxWidth={maxWidth}
         trigger="click"
         interactive={true}
         hideOnClick={true}
         placement={placement || "top"}
         arrow={true}
         onShow={onShow}
         onHide={onHide}
      >
         {customTrigger ? (
            customTrigger
         ) : (
            <button
               type="button"
               className={styles.button}
               style={{...inlineStyle}}
               aria-label={ariaLabel}
               onClick={(e) => e.stopPropagation()}
            >
               <Svg 
                  id={isOpen ? openIcon : closedIcon} 
                  width={width} 
                  height={height} 
               />
            </button>
         )}
      </Tippy>
   )
}

export default memo(InfoTooltip)
